// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-credentials {
  width: 485px;
  padding: 13px 20px 24px 20px;
}
.credentials-header {
  font-size: 20px;
  font-weight: 600;
  color: #54595e;
  margin-bottom: 20px;
}
.customer-credentials-title {
  color: #54595e;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 13px;
}
.customer-credentials-content {
  color: #54595e99;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 24px;
}
.customer-credentials-pin,
.customer-credentials-password {
  font-weight: 700;
  font-size: 14px;
  font-style: italic;
  color: #54595e;
}
.customer-credentials-pin {
  margin-bottom: 24px;
}
.customer-credentials-password {
  margin-bottom: 13px;
}
.customer-credentials-signature {
  color: #54595e;
  font-size: 14px;
  font-weight: 400;
}
.credentials_cancel,
.credentials_send {
  width: 148px;
}
.credentials_send {
  background-color: #f15e22;
  border: none;
  color: #ffffff;
  margin-left: 24px;
}
.customer-credentials-action-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/components/credentialsPopup/credentialsPopup.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".customer-credentials {\n  width: 485px;\n  padding: 13px 20px 24px 20px;\n}\n.credentials-header {\n  font-size: 20px;\n  font-weight: 600;\n  color: #54595e;\n  margin-bottom: 20px;\n}\n.customer-credentials-title {\n  color: #54595e;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 13px;\n}\n.customer-credentials-content {\n  color: #54595e99;\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 24px;\n}\n.customer-credentials-pin,\n.customer-credentials-password {\n  font-weight: 700;\n  font-size: 14px;\n  font-style: italic;\n  color: #54595e;\n}\n.customer-credentials-pin {\n  margin-bottom: 24px;\n}\n.customer-credentials-password {\n  margin-bottom: 13px;\n}\n.customer-credentials-signature {\n  color: #54595e;\n  font-size: 14px;\n  font-weight: 400;\n}\n.credentials_cancel,\n.credentials_send {\n  width: 148px;\n}\n.credentials_send {\n  background-color: #f15e22;\n  border: none;\n  color: #ffffff;\n  margin-left: 24px;\n}\n.customer-credentials-action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
